<div class="flx-modal" role="dialog" aria-modal="true" aria-labelledby="assignTitle">
  <div class="flx-modal__header">
    <h2 id="assignTitle">Update the assignee and scheduled date</h2>
    <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular"
      aria-label="Close" (click)="modalRef.hide()">
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>

  <form [formGroup]="assigneeForm">
    <div class="flx-modal__body">

      <!-- ── Assign to ────────────────────────────────────────────────── -->
      <label class="field-label mandatory">Assign to</label>
      <div class="field-row field-row--auto mb-3">
        <p-dropdown
          [options]="assignedToOptions"
          formControlName="assignTo"
          optionLabel="name"
          optionValue="value">
        </p-dropdown>

        <!-- User dropdown -->
        <p-dropdown
          *ngIf="assigneeForm.get('assignTo')?.value === 'user'"
          [placeholder]="'Select user'"
          [filter]="true"
          [options]="userList"
          optionLabel="fullName"
          optionValue="id"
          styleClass="assignee-dropdown-panel"
          formControlName="assignToGroup">
        </p-dropdown>

        <!-- Group dropdown -->
        <div *ngIf="assigneeForm.get('assignTo')?.value === 'group'">
          <p-dropdown
            [placeholder]="'Select group'"
            [filter]="true"
            [options]="groupList"
            optionLabel="name"
            optionValue="id"
            formControlName="assignToGroup">
          </p-dropdown>
          <div class="p-error text-10"
            *ngIf="assigneeForm.controls['assignToGroup'].touched &&
                   assigneeForm.controls['assignToGroup'].hasError('required')">
            <span>{{ translate?.general.validationFE.requiredField }}</span>
          </div>
        </div>
      </div>

      <!-- ── Group note ─────────────────────────────────────────────── -->
      <div class="note mb-2" *ngIf="assigneeForm.get('assignTo')?.value === 'group'">
        <div class="icon">
          <i class="fa-regular fa-circle-info" aria-hidden="true"></i>
        </div>
        <p>Job Order will be assigned to group members in a round-robin order.</p>
      </div>

    <!-- ── Order date ─────────────────────────────────────────────── -->
<div class="mb-2">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <label class="field-label mb-0">Order date</label>
    <span class="text-12 color-muted" *ngIf="installationTime">
      Current order date: <b>{{ installationTime | momentDate :'hh:mma, dd-MM-yyyy' }}</b>
    </span>
  </div>

  <!-- ── Start & End datetime inputs ── -->
                        

                        <div class="sd-inline-field d-flex mb-2 align-items-center gap-1">
                            <div class="req-input-field w-50">
                                <span class="w-50">
                                    <p-calendar dateFormat="dd/mm/yy" selectionMode="single" yearRange="2000:2050"
                                        [placeholder]="translate?.general.messages.none" styleClass="cal-btn"
                                        formControlName="orderDate" name="orderDate"
                                         appendTo="body" [showTime]="true" [showIcon]="true" 
                                        hourFormat="12" [yearNavigator]="true" id="picklist_JobDateTimeField"
                                        (onSelect)="onOrderDateChange($event)" appendTo="body"></p-calendar>
                                </span>
                                <div class="p-error text-10"
                                    *ngIf=" assigneeForm.controls['orderDate'].touched && assigneeForm.controls['orderDate'].invalid ">
                                    <span *ngIf=" assigneeForm.controls['orderDate']?.errors?.required"
                                        id="label_JobNoteReqField">{{translate?.general.validationFE.requiredField}}</span>
                                </div>

                            </div>
                            <label for="endDate">-</label>
                            <div class="req-input-field w-50">
                                <span class="w-50">
                                    <p-calendar [minDate]="minDateForEndDate" dateFormat="dd/mm/yy" yearRange="2000:2050"
                                        selectionMode="single" [placeholder]="translate?.general.messages.none"
                                        formControlName="endDate" name="endDate" [showIcon]="true" 
                                        appendTo="body" [showTime]="true"
                                        hourFormat="12" [yearNavigator]="true" id="picklist_JobDateTimeField"
                                        appendTo="body" styleClass="cal-btn"
                                         (onSelect)="onEndDateChange($event)" (ngModelChange)="onEndDateChange($event)"></p-calendar>
                                </span>
                                <div class="p-error text-10"
                                    *ngIf=" assigneeForm.controls['endDate'].touched && assigneeForm.controls['endDate'].invalid ">
                                    <span *ngIf=" assigneeForm.controls['endDate']?.errors?.required"
                                        id="label_JobNoteReqField">{{translate?.general.validationFE.requiredField}}</span>
                                </div>
                            </div>
                        </div>
                    
  <!-- ── Duration chips ── -->
  <div class="d-flex flex-wrap gap-2 mb-2">
    <div class="mp-note-option" 
      [class.is-selected]="selectedDuration === 15"
      (click)="setDuration(15)">15 min</div>
    <div class="mp-note-option"
      [class.is-selected]="selectedDuration === 30"
      (click)="setDuration(30)">30 min</div>
    <div class="mp-note-option"
      [class.is-selected]="selectedDuration === 60"
      (click)="setDuration(60)">1 hr</div>
    <div class="mp-note-option"
      [class.is-selected]="selectedDuration === 120"
      (click)="setDuration(120)">2 hr</div>
    <div class="mp-note-option"
      [class.is-selected]="selectedDuration === 240"
      (click)="setDuration(240)">4 hr</div>
    <div class="mp-note-option"
      [class.is-selected]="selectedDuration === 480"
      (click)="setDuration(480)">8 hr</div>

       <div class="mp-note-option me-1" [class.is-selected]="selectedDate === 'today'" (click)="setDate('today')">Today</div>
    <div class="mp-note-option me-1" [class.is-selected]="selectedDate === 'tomorrow'" (click)="setDate('tomorrow')">Tomorrow</div>
  </div>

  <!-- ── Today / Tomorrow shortcuts ── -->
  <!-- <div class="mp-inline-row-box mp-row">
    <div class="mp-note-option me-1" (click)="setDate('today')">Today</div>
    <div class="mp-note-option me-1" (click)="setDate('tomorrow')">Tomorrow</div>
  </div> -->

</div>

      <!-- ── Apply to all tasks ─────────────────────────────────────── -->
      <div class="apply-all-tasks">
        <div class="apply-all-tasks__inner">
          <p-checkbox [binary]="true" formControlName="applyToAllTask"></p-checkbox>
          <div>
            <div class="text-14 font-medium">Apply to all added tasks</div>
            <div class="text-12 color-muted">These changes will update every task in this order</div>
          </div>
        </div>
      </div>

    </div>

    <div class="flx-modal__footer-between">
      <div></div>
      <div class="triggers">
        <button type="button" class="custella-btn-white"
          (click)="modalRef.hide()">
          {{ translate?.general.buttons.cancel.singular }}
        </button>
        <p-button type="button"
          [label]="translate?.general.buttons.save.singular ?? 'Save'"
          styleClass="h-32"
          (onClick)="onConfirmClick()">
        </p-button>
      </div>
    </div>
  </form>
</div>